import FollowUpBossAttributes from './FollowUpBossAttributes';

export default FollowUpBossAttributes;
